import { render, staticRenderFns } from "./ExpertHeader.vue?vue&type=template&id=6af7ebbe&"
import script from "./ExpertHeader.vue?vue&type=script&lang=js&"
export * from "./ExpertHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExpertHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports